import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Row, Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import ViewAllFixedPagesHook from "../../hook/admin/ViewAllFixedPagesHook";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AddButton from "../Utilities/AddButton";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const AdminAllFixedPages = () => {
    //console.log('fixed pages');
    const { t } = useTranslation();
    const[FixedPages, clickHandler, handleShowFun] = ViewAllFixedPagesHook();

    const navigate = useNavigate();

   let columns = [
     {
       name: t("name"),
       selector: "title",
       sortable: true,
     },

     {
        name: t("image"),
        cell: (row) => (
          // eslint-disable-next-line jsx-a11y/alt-text
          <img
            src={row.image}
            width="80px"
            height="80px"
            style={{
              padding: "2px",
              justifyContent: "center",
              alignItems: "center",
              objectFit: "contain",
            }}
          />
        ),
      },
        
     {
       name: t("modify"),
       cell: (row) => (
         <Button
           variant="secondary"
           onClick={() => clickHandler(row._id)}
           id={row._id}
         >
           {t("Modify")}
           <i className="fa fa-pencil-square-o mx-1" />
         </Button>
       ),
       ignoreRowClick: true,
       allowOverflow: true,
       button: true,
     },
     {
       name: t("state"),
       cell: (row) =>
         row.status == true ? (
           <Button
             variant="danger"
             onClick={() => {
               handleShowFun(row._id, false);
             }}
             id={row._id}
           >
             {t("block")}
             <i className="fa fa-lock mx-1" />
           </Button>
         ) : (
           <Button
             variant="success"
             onClick={() => {
               handleShowFun(row._id, true);
             }}
             id={row._id}
           >
             {t("active")}
             <i className="fa fa-unlock mx-1" />
           </Button>
         ),
       ignoreRowClick: true,
       allowOverflow: true,
       button: true,
     },
   ];
 
   const tableData = {
     columns,
     data: FixedPages,
   };
 
   return (
     <div>
 
       <title>الصفحات الثابتة </title>
 
       <div className="d-flex justify-content-between">
         <div className="admin-content-text">ادارة الصفحات الثابتة </div>
         <AddButton title='اضافة ' navigateTo='/admin/addFixedPage' />
 
       </div>
 
       <DataTableExtensions {...tableData} filterPlaceholder={t("search here")}>
         <DataTable
           noHeader
           defaultSortAsc={false}
           pagination
           highlightOnHover
         />
       </DataTableExtensions>
       <ToastContainer />
     </div>
   );
    
}

export default AdminAllFixedPages;